
















































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import dialogNewUsuario from '@/components/dialogNewUsuario.vue'
import dialogNewRolUsuario from '@/components/dialogNewRolUsuario.vue'
import { HTTP } from '@/plugins/axios'
import { DeleteRolInfoDTO, RolDTO } from '@/interfaces/UsuariosRol.interface'
import { DialogConfirmActionDTO } from '@/interfaces/DialogConfirmAction.interface'
import { DeleteUsuarioInfoDTO, UserDTO, UserTextMsg } from '@/interfaces/Usuarios.interface'
import { TextMSGDTO } from '@/interfaces/DialogNewRolUsuario.interface'

@Component ({
  components: {
    dialogNewUsuario,
    dialogNewRolUsuario
  }
})
export default class ViewUsuarios extends Vue {
  private name: string = 'ViewUsuarios'
  private tab: number = 1
  /* ROLES */
  private infoRoles: object = {}
  private headersRoles: any[] = [
    {
      text: 'Nombre',
      align: 'left',
      sortable: true,
      value: 'name'
    },
    { text: 'Solo Lectura', value: 'isOnlyRead' },
    { text: 'Acciones', value: 'acciones' }
  ]
  private tableRoles: RolDTO[] = []
  private actionRoles: string = 'new'
  private updateRolTable: boolean = false
  private deleteRolInfo: DeleteRolInfoDTO = {
    id: 0,
    name: ''
  }
  /* USUARIOS */
  private infoUsuario: object = {}
  private headers: any[] = [
    {
      text: 'Nombre',
      align: 'left',
      sortable: true,
      value: 'name'
    },
    { text: 'Email', value: 'email' },
    { text: 'Rol', value: 'rol' },
    { text: 'Acciones', value: 'acciones' }
  ]
  private tableUsuarios: UserDTO[] = []
  private updateUsuarioTable: boolean = false
  private actionUsuario: string = 'new'
  private textBlockUsuarioMSG: TextMSGDTO = {
    success: {
      text: 'Nuevo Usuario:',
      color: 'success'
    },
    update: {
      text: 'Modificado Usuario:',
      color: 'info'
    },
    block: {
      text: 'Modificado Usuario:',
      color: 'info'
    },
    fail: {
      text: 'Error al guardar:',
      color: 'error'
    },
  }
  private deleteUsuarioInfo: DeleteUsuarioInfoDTO = {
    id: 0,
    name: ''
  }
  /* SNACKBAR */
  private textMSG: UserTextMsg = {
    deleteRol: {
      success: {
        text: 'Eliminado Rol:',
        color: 'success'
      },
      fail: {
        text: 'Error al eliminar Rol:',
        color: 'error'
      },
    },
    deleteUsuario: {
      success: {
        text: 'Eliminado Usuario:',
        color: 'success'
      },
      fail: {
        text: 'Error al eliminar usuario:',
        color: 'error'
      },
    },
    blockUsuario: {
      success: {
        text: 'Usuario Bloqueado:',
        color: 'success'
      },
      fail: {
        text: 'Error al bloquear usuario:',
        color: 'error'
      },
    },
    UnBlockUsuario: {
      success: {
        text: 'Usuario Des-Bloqueado:',
        color: 'success'
      },
      fail: {
        text: 'Error al Des-bloquear Usuario:',
        color: 'error'
      },
    }
  }
  /* CONFIRM ACTION USUARIO */
  private ConfirmDeleteUsuarioInfo: DialogConfirmActionDTO = {
    title: 'Eliminar Usuario',
    msg: 'Esta seguro que desea eliminar el usuario:',
    color: 'error',
    show: true,
    status: undefined,
    action: 'deleteUsuario'
  }
  /* CONFIRM ACTION ROL */
  private ConfirmDeleteRolInfo: DialogConfirmActionDTO = {
    title: 'Eliminar Rol de Usuario',
    msg: 'Esta seguro que desea eliminar el Rol:',
    color: 'error',
    show: true,
    status: undefined,
    action: 'deleteUsuarioRol'
  }
  private get ConfirmDeleteAction (): DialogConfirmActionDTO {
    console.log('ViewUsuarios :: ConfirmDeleteAction :: ', this.$store.state.appState.DialogConfirmAction)
    return this.$store.state.appState.DialogConfirmAction
  }
  @Watch('ConfirmDeleteAction')
  private watchConfirmDeleteAction (v: DialogConfirmActionDTO) {
    console.log('watchConfirmDeleteAction :: ', v)
    if ((v.action === 'deleteUsuarioRol') && (v.status)) {
      console.log('watchConfirmDeleteAction :: DeleteRol :: ', this.deleteRolInfo)
      this.DeleteRol (this.deleteRolInfo.id, this.deleteRolInfo.name)
    } else if ((v.action === 'deleteUsuario') && (v.status)) {
      console.log('watchConfirmDeleteAction :: deleteUsuario :: ', this.deleteRolInfo)
      this.DeleteUsuario (this.deleteUsuarioInfo.id, this.deleteUsuarioInfo.name)
    }
  }
  /* USUARIOS */
  @Watch('updateUsuarioTable')
  private watchUpdateUsuarioTable (v: boolean) {
    console.log('watchUpdateUsuarioTable :: ', v)
    if (v) {
      this.gShowAllUser()
      this.updateUsuarioTable = false
    }
  }
  private gShowAllUser () {
    HTTP.get('user/')
      .then((response) => {
        console.log('gShowAllUser :: response :: ', response.data)
        this.tableUsuarios = response.data
      })
      .catch((e) => {
        console.log('gShowAllUser :: catch :: ', e.response.data)
      })
  }
  private editUser (item: UserDTO) {
    console.log('editRol :: ', item)
    this.infoUsuario = Object.assign({}, item)
    this.actionUsuario = 'edit'
  }
  private BlockUsuario (item: UserDTO) {
    console.log('UpdateUsuario :: ', item)
    let status = 'block'
    let snackbarMSG = this.textMSG.blockUsuario
    if (item.status) {
      status = 'unblock'
      snackbarMSG = this.textMSG.UnBlockUsuario
    }

    HTTP.get('user/' + item.id + '/' + status)
      .then((response) => {
        console.log('BlockUsuario :: response :: ', response.data)
        this.$store.commit('setSnackbarMsg',  {
          text: snackbarMSG.success.text + ' ' + item.name,
          color: snackbarMSG.success.color,
          show: true,
          timeout: 2000
        })
        this.gShowAllUser ()
      })
      .catch((e) => {
        console.log('BlockUsuario :: catch :: ', e.response.data)
        this.$store.commit('setSnackbarMsg',  {
          text: snackbarMSG.fail.text + ' ' + item.name,
          color: snackbarMSG.fail.color,
          show: true,
          timeout: 2000
        })
      })
  }
  private ConfirmDeleteUsuario (id: number, name: string) {
    console.log('ConfirmDeleteUsuario :: id :: ', id)
    console.log('ConfirmDeleteUsuario :: name :: ', name)

    this.deleteUsuarioInfo.id = id
    this.deleteUsuarioInfo.name = name

    this.$store.commit('setDialogConfirmAction',  {
      title: this.ConfirmDeleteUsuarioInfo.title,
      msg: this.ConfirmDeleteUsuarioInfo.msg + ' ' + name,
      color: this.ConfirmDeleteUsuarioInfo.color,
      show: this.ConfirmDeleteUsuarioInfo.show,
      status: this.ConfirmDeleteUsuarioInfo.status,
      action: this.ConfirmDeleteUsuarioInfo.action
    })
  }
  private DeleteUsuario (id: number, name: string) {
    console.log('DeleteUsuario :: ', id)
    console.log('DeleteUsuario :: ', name)
    HTTP.delete('user/' + id)
      .then((response) => {
        console.log('DeleteUsuario :: response :: ', response.data)
        this.updateUsuarioTable = true
        this.$store.commit('setSnackbarMsg',  {
          text: this.textMSG.deleteUsuario.success.text + ' ' + name,
          color: this.textMSG.deleteUsuario.success.color,
          show: true,
          timeout: 2000
        })
      })
      .catch((e) => {
        console.log('DeleteUsuario :: catch :: ', e.response.data)
        this.$store.commit('setSnackbarMsg',  {
          text: this.textMSG.deleteUsuario.fail.text + ' ' + name,
          color: this.textMSG.deleteUsuario.fail.color,
          show: true,
          timeout: 2000
        })
      })
  }
  /* ROLES */
  @Watch('updateRolTable')
  private watchUpdateRolTable (v: boolean) {
    console.log('watchUpdateRolTable :: ', v)
    if (v) {
      this.gShowAllRol()
      this.updateRolTable = false
    }
  }

  private editRol (item: RolDTO) {
    console.log('editRol :: ', item)
    this.infoRoles = Object.assign({}, item)
    this.actionRoles = 'edit'
  }
  private gShowAllRol () {
    console.log('gShowAllRol :: ')
    HTTP.get('rol/')
      .then((response) => {
        console.log('gShowAllRol :: response :: ', response.data)
        this.tableRoles = response.data
      })
      .catch((e) => {
        console.log('gShowAllRol :: catch :: ', e.response.data)
      })
  }
  private ConfirmDeleteRol (id: number, name: string) {
    console.log('ConfirmDeleteRol :: id :: ', id)
    console.log('ConfirmDeleteRol :: name :: ', name)

    this.deleteRolInfo.id = id
    this.deleteRolInfo.name = name

    this.$store.commit('setDialogConfirmAction',  {
      title: this.ConfirmDeleteRolInfo.title,
      msg: this.ConfirmDeleteRolInfo.msg + ' ' + name,
      color: this.ConfirmDeleteRolInfo.color,
      show: this.ConfirmDeleteRolInfo.show,
      status: this.ConfirmDeleteRolInfo.status,
      action: this.ConfirmDeleteRolInfo.action
    })
  }
  private DeleteRol (id: number, name: string) {
    console.log('DeleteRol :: ', id)
    console.log('DeleteRol :: ', name)
    HTTP.delete('rol/' + id)
      .then((response) => {
        console.log('DeleteRol :: response :: ', response.data)
        this.updateRolTable = true
        this.$store.commit('setSnackbarMsg',  {
          text: this.textMSG.deleteRol.success.text + ' ' + name,
          color: this.textMSG.deleteRol.success.color,
          show: true,
          timeout: 2000
        })
      })
      .catch((e) => {
        console.log('DeleteRol :: catch :: ', e.response.data)
        this.$store.commit('setSnackbarMsg',  {
          text: this.textMSG.deleteRol.fail.text + ' ' + name,
          color: this.textMSG.deleteRol.fail.color,
          show: true,
          timeout: 2000
        })
      })
  }

  private beforeMount () {
    console.log('beforeMount :: ', this.name)
    this.gShowAllRol ()
    this.gShowAllUser ()
  }
}
